import React from "react";
import { string, bool, object } from "prop-types";
import { Link } from "@quintype/components";
import { connect } from "react-redux";
import get from "lodash/get";
import { flatten } from "lodash";

import { MICROSITES_OLD_URLS } from "../../../../server/helpers/constants";

import Headline from "../Headline";

import "./collection-title-with-arrow.m.css";

const CollectionTitleWithArrow = ({
  collectionSlug,
  collectionName,
  headlineClassName = "",
  updatedFont = false,
  publisherAttributes,
}) => {
  const genCollectionSlug = () => {
    const flattenedUrls = flatten(MICROSITES_OLD_URLS);
    const slugIndex = flattenedUrls.indexOf(collectionSlug);
    return slugIndex >= 0 ? flattenedUrls[slugIndex + 1] : collectionSlug;
  };

  const headlineStyle = updatedFont ? `${publisherAttributes.lang}-collection-title` : "";
  return (
    <Link href={genCollectionSlug()}>
      <Headline text={collectionName} headerLevel={2} className={headlineClassName} styleName={headlineStyle} />
    </Link>
  );
};

CollectionTitleWithArrow.propTypes = {
  collectionName: string,
  collectionSlug: string,
  headlineClassName: string,
  updatedFont: bool,
  publisherAttributes: object,
};

const mapStateToProps = (state) => ({
  sections: get(state, ["qt", "config", "sections"], []),
  publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {}),
});

export default connect(mapStateToProps, null)(CollectionTitleWithArrow);
